import { __extends } from 'tslib';
import React__default from 'react';
import WordLogo from '../WordLogo/WordLogo.component.js';
import { propTypes } from './LeftNavVerticalsMenu.types.js';
import styles from './LeftNavVerticalsMenu.module.scss.js';

var LeftNavVerticalsMenu = /** @class */ (function (_super) {
    __extends(LeftNavVerticalsMenu, _super);
    function LeftNavVerticalsMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            overlayIsVisible: false,
            overlayIsOpaque: false,
        };
        /**
         * We keep the overlay status in state to:
         * a) Only remove the overlay after the transition was completed.
         * b) Make sure the transition happens.
         * (ie. Make sure the overlay gets rendered with opacity 0, and then with opacity 1)
         */
        _this.updateOverlay = function (_a) {
            var wasOpen = _a.wasOpen;
            var didOpen = !wasOpen && _this.props.isOpen;
            var didClose = wasOpen && !_this.props.isOpen;
            // Makes sure the opacity transition always happens
            if (didOpen) {
                _this.setState({
                    overlayIsVisible: true,
                    // Make sure the overlay gets rendered with opacity 0
                    overlayIsOpaque: false,
                });
                setTimeout(function () {
                    // And right after with opacity 1
                    _this.setState({ overlayIsOpaque: true });
                }, 0);
            }
            if (didClose) {
                // Starts the transition to opacity 0
                _this.setState({ overlayIsOpaque: false });
                setTimeout(function () {
                    // Wait until transition is completed to remove the overlay
                    _this.setState({ overlayIsVisible: false });
                }, 200); // <- NOTE: This value needs to match the transition duration!
            }
        };
        _this.handleKeydown = function (event) {
            if (event.key === 'Escape') {
                _this.props.onClose();
            }
        };
        return _this;
    }
    LeftNavVerticalsMenu.prototype.componentDidMount = function () {
        this.updateOverlay({ wasOpen: false });
        document.addEventListener('keydown', this.handleKeydown);
    };
    LeftNavVerticalsMenu.prototype.componentDidUpdate = function (prevProps) {
        this.updateOverlay({ wasOpen: prevProps.isOpen });
    };
    LeftNavVerticalsMenu.prototype.componentWillUnmount = function () {
        document.removeEventListener('keydown', this.handleKeydown);
    };
    LeftNavVerticalsMenu.prototype.render = function () {
        var _this = this;
        var _a = this.props, isOpen = _a.isOpen, applicationName = _a.applicationName, links = _a.links, onClose = _a.onClose;
        var _b = this.state, overlayIsVisible = _b.overlayIsVisible, overlayIsOpaque = _b.overlayIsOpaque;
        return (React__default.createElement("div", null,
            overlayIsVisible ? (React__default.createElement("div", { className: "\n                            " + styles.Overlay + "\n                            " + (overlayIsOpaque
                    ? styles.Overlay___active
                    : styles.Overlay___inactive) + "\n                        ", onClick: onClose })) : (''),
            React__default.createElement("div", { className: styles.LeftNavAppMenu + " " + (isOpen ? styles.LeftNavAppMenu___open : '') },
                React__default.createElement("div", { className: styles.LeftNavAppMenu_header },
                    React__default.createElement("div", { className: styles.HeaderContents },
                        React__default.createElement("div", { className: styles.HeaderContents_logo, onClick: onClose },
                            React__default.createElement(WordLogo, null)),
                        React__default.createElement("span", { className: styles.HeaderContents_text }, applicationName))),
                React__default.createElement("nav", { className: "" + styles.LeftNavAppMenu_content },
                    React__default.createElement("ul", { className: styles.VerticalNav }, links.map(function (link) { return (React__default.createElement("li", { key: link.id },
                        React__default.createElement("button", { className: styles.NavLink + " " + (link.isActive
                                ? styles.NavLink___active
                                : ''), onClick: function (event) {
                                event.preventDefault();
                                _this.props.onSelectLink(link);
                            } }, link.displayName))); }))))));
    };
    LeftNavVerticalsMenu.displayName = 'LeftNavVerticalsMenu';
    LeftNavVerticalsMenu.propTypes = propTypes;
    return LeftNavVerticalsMenu;
}(React__default.Component));

export { LeftNavVerticalsMenu, LeftNavVerticalsMenu as default };
